/// @flow
import * as React from 'react';
import CurrencyTextField from 'app/common/react/components/profile/storefront/Filter/CurrencyTextField';
import i18n from 'app/common/lib/i18n';
import { currencySymbols } from 'app/common/lib/locale';
import { microCurrencyToCurrency } from 'app/common/lib/NumberUtil';
import { Box, Column, IconButton, Text } from 'gestalt';

const DEFAULT_PRICE_VALUE = -1;

type Props = {|
  currencyCode: string,
  currentMaxValue: number,
  currentMinValue: number,
  handleMaxPrice: (value: ?number) => void,
  handleMinPrice: (value: ?number) => void,
  maxValue: number,
  minValue: number,
|};

type State = {|
  isOpen: boolean,
|};

class PriceFilter extends React.PureComponent<Props, State> {
  state = {
    isOpen: false,
  };

  render() {
    const { currencyCode, minValue, maxValue, currentMaxValue, currentMinValue } = this.props;
    const currencySign = currencySymbols[currencyCode] || '';

    return (
      <Box>
        <Box display="flex" alignItems="center" justifyContent="between">
          <Box minWidth={0} width="100%">
            <Text weight="bold">
              {i18n._('Price', 'Header of product group price filter containing filter options')}
            </Text>
          </Box>
          <Box flex="none" data-test-id="clear-button">
            <IconButton
              icon={this.state.isOpen ? 'arrow-up' : 'arrow-down'}
              accessibilityLabel={i18n._('price filters icon', '[bizpro]- opens price filter')}
              onClick={() => this.setState({ isOpen: !this.state.isOpen })}
              size="sm"
            />
          </Box>
        </Box>
        <Box marginTop={1} marginBottom={2}>
          {this.state.isOpen ? (
            <Column span={12}>
              <Box display="flex" direction="row">
                <Column span={5}>
                  <Box display="flex" flex="grow" direction="column" marginEnd={1}>
                    <Text size="sm">{i18n._('Min', 'Minimum Price')}</Text>
                    <Box paddingY={2}>
                      <CurrencyTextField
                        id="min_price"
                        autoComplete="off"
                        placeholder={currencySign}
                        onValueParsed={(value) => {
                          this.props.handleMinPrice(value);
                        }}
                        type="text"
                        currencyCode={currencyCode}
                        valueInMicroCurrency={
                          currentMinValue === DEFAULT_PRICE_VALUE ? null : currentMinValue
                        }
                      />
                    </Box>
                  </Box>
                </Column>
                <Column span={2}>
                  <Box
                    display="flex"
                    flex="grow"
                    justifyContent="center"
                    direction="row"
                    marginEnd={1}
                    lgPaddingY={9}
                  >
                    <Text size="sm" color="gray">
                      {i18n._('to', 'Min to Max')}
                    </Text>
                  </Box>
                </Column>
                <Column span={5}>
                  <Box display="flex" flex="grow" direction="column" marginStart={1}>
                    <Text size="sm">{i18n._('Max', 'Maximum Price')}</Text>
                  </Box>
                  <Box paddingY={2}>
                    <CurrencyTextField
                      id="max_price"
                      autoComplete="off"
                      placeholder={`${currencySign}${currencySign}${currencySign}`}
                      onValueParsed={(value) => {
                        this.props.handleMaxPrice(value);
                      }}
                      type="text"
                      currencyCode={currencyCode}
                      valueInMicroCurrency={
                        currentMaxValue === DEFAULT_PRICE_VALUE ? null : currentMaxValue
                      }
                    />
                  </Box>
                </Column>
              </Box>
            </Column>
          ) : (
            <Text size="sm" color="gray">
              {(minValue === currentMinValue && maxValue === currentMaxValue) ||
              (currentMinValue === DEFAULT_PRICE_VALUE &&
                currentMaxValue === DEFAULT_PRICE_VALUE) ? (
                <Box>{i18n._('All', 'All collective pins. No filtering is conducted.')}</Box>
              ) : (
                <Box>
                  {currencySign}
                  {currentMinValue === DEFAULT_PRICE_VALUE
                    ? microCurrencyToCurrency(minValue)
                    : microCurrencyToCurrency(currentMinValue)}
                  -{currencySign}
                  {currentMaxValue === DEFAULT_PRICE_VALUE
                    ? microCurrencyToCurrency(maxValue)
                    : microCurrencyToCurrency(currentMaxValue)}
                </Box>
              )}
            </Text>
          )}
        </Box>
      </Box>
    );
  }
}

export default PriceFilter;
